module.exports = __webpack_public_path__ + "static/media/germany.d0fb7f40.svg";